import { useState } from "react";
import { useCentralStore } from "../../../store/Central";
import { ConnectRelationshipClientSelect } from "./cr-select/connect-relationship-client-select.component";
import { Button } from "../../../components/ui/button";

export const ShareConnectRelationshipWithClient: React.FC = () => {
	const { connectClientToAlreadyConnectedOrg } = useCentralStore(
		(state) => ({
			connectClientToAlreadyConnectedOrg:
				state.connectClientToAlreadyConnectedOrg,
		})
	);
	const [selectedConnectedOrganizationId, setSelectedConnectedOrganizationId] = useState<
		string | null
	>(null);

	return (
		<div>
			<h2 className="text-sm text-gray-500 mb-4">
				Sie können mehrere Auftraggeber für die gleiche Connect-Beziehung nutzen. Die Praxis erhält dann von beiden Auftraggebern Aufträge zum gleichen Praxis-Account.
			</h2>
			
			<ConnectRelationshipClientSelect
				onSelect={(connectedOrganizationId) => {
					setSelectedConnectedOrganizationId(connectedOrganizationId);
				}}
			/>
			
			<div className="mt-4">
				<Button
					onClick={() => {
						if (!selectedConnectedOrganizationId) return;
						connectClientToAlreadyConnectedOrg(
							selectedConnectedOrganizationId
						);
					}}
					disabled={!selectedConnectedOrganizationId}
					variant={selectedConnectedOrganizationId ? "default" : "secondary"}
					size="sm"
				>
					Connect-Beziehung teilen
				</Button>
			</div>
		</div>
	);
};
